/** Split stored website into protocol prefix and host/path for editing. */
export function parseWebsiteUrl(url) {
  if (url == null || !String(url).trim()) {
    return { protocol: 'https://', host: '' };
  }
  const s = String(url).trim();
  const lower = s.toLowerCase();
  if (lower.startsWith('https://')) {
    return { protocol: 'https://', host: s.slice(8).replace(/^\/+/, '') };
  }
  if (lower.startsWith('http://')) {
    return { protocol: 'http://', host: s.slice(7).replace(/^\/+/, '') };
  }
  return { protocol: 'https://', host: s.replace(/^\/+/, '') };
}

/** Build full URL for API; empty host yields empty string. */
export function combineWebsiteUrl(protocol, host) {
  const h = String(host || '').trim();
  if (!h) return '';
  const p = protocol === 'http://' ? 'http://' : 'https://';
  return p + h.replace(/^\/+/, '');
}

/** Safe href for links when legacy data may omit protocol. */
export function websiteHref(url) {
  if (url == null || !String(url).trim()) return '';
  const s = String(url).trim();
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s.replace(/^\/+/, '')}`;
}
